import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

class TextInput extends React.PureComponent {
  componentDidMount() {
    const { id } = this.props;
    this.handleChange({ target: { id } });
  }

  validate = (value) => {
    const { pattern } = this.props;
    const matches = value.match(pattern) || [];
    return matches.length > 0;
  };

  handleChange = ({ target }) => {
    const {
      dispatch,
      value: defaultValue,
      category,
      categoryType,
      buttonNumber,
      objectKey,
    } = this.props;
    const { id, value = defaultValue } = target;

    const valid = this.validate(value || '');

    if (categoryType === 'array') {
      dispatch({
        type: 'EDIT_SITE_THEME',
        value,
        valid,
        category,
        categoryType,
      });
    } else if (categoryType === 'object') {
      dispatch({
        type: 'EDIT_SITE_THEME',
        id,
        value,
        valid,
        category,
        categoryType,
      });
    } else if (categoryType === 'arrayWithinObject') {
      dispatch({
        type: 'EDIT_SITE_THEME',
        id,
        value,
        valid,
        category,
        categoryType,
        buttonNumber,
        objectKey,
      });
    } else {
      dispatch({
        type: 'EDIT_SITE_THEME',
        id,
        value,
        valid,
      });
    }
  };

  render() {
    const {
      values,
      id,
      label,
      saving,
      disabled,
      validations,
      type,
      value,
    } = this.props;
    const valid = validations[id];

    return (
      <FormGroup>
        <Label for={id} className="font-weight-bold">
          {label}
        </Label>
        <Input
          id={id}
          name={id}
          className="border"
          value={value || values[id] || ''}
          onChange={this.handleChange}
          invalid={!valid}
          disabled={disabled || saving}
          type={type}
        />
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  saving: store.sites.saving,
  values: store.sites.values,
  validations: store.sites.validations,
});

export default connect(mapStateToProps)(TextInput);
